import {MenuItem} from "@mui/material";
import React from "react";
import {GetCookieInfo} from "./CookieManager";

const lookups = {}

export function CacheLookupsForClient () {
    fetchAssets();
    fetchCountries();
    fetchNationalities();
    UpdateBanksCache();
}

export function CacheLookupsForManager () {
    fetchAssets();
    fetchCountries();
    fetchNationalities();
    UpdateBanksCache();
    fetchAccounts();
}
const fetchAssets = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(process.env.REACT_APP_ASSETS_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + tokenCookie.value,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const assets = data.data;
            UpsertLookup('asset', assets);
        } else {
            console.log('Fetch assets failed.');
        }
    } catch (error) {
        // Handle network errors or other exceptions
        console.log('An error occurred:', error);
    }
};
const fetchCountries = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(process.env.REACT_APP_COUNTRIES_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + tokenCookie.value,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const countries = data.data;
            UpsertLookup('country', countries);
        } else {
            console.log('Fetch countries failed.');
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};
const fetchNationalities = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(process.env.REACT_APP_NATIONALITIES_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + tokenCookie.value,
            },
        });
        if (response.ok) {
            const data = await response.json();
            UpsertLookup('nationality', data.data);
        } else {
            console.log('Fetch nationalities failed.');
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};
export const UpdateBanksCache = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(process.env.REACT_APP_BANKS_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + tokenCookie.value,
            },
        });
        if (response.ok) {
            const data = await response.json();
            UpsertLookup('bank', data.data);
        } else {
            console.log('Fetch banks failed.');
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};
const fetchAccounts = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_BANK_ACCOUNTS_URL}/${process.env.REACT_APP_NEWCENT_CONTACT_ID}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
            });
        if (response.ok) {
            const data = await response.json();
            if (data.data) {
                UpsertLookup('ownBankAccounts', data.data);
            }
        } else {
            console.log('Fetch Own Bank Accounts failed.');
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};

export function UpsertLookup(name, values) {

    let remasteredValues = [];

    values.forEach((value, index) => {

        if (name === 'asset') {
            remasteredValues.push({
                id: value.id,
                name: value.name,
                type: value.type
            });
        } else if (name === 'ownBankAccounts') {
            remasteredValues.push({
                id: value.id,
                name: value.iban,
                assetId: value.assetId
            });
        } else if (name === "bank") {
            remasteredValues.push({
                id: value.id,
                name: value.name,
                countryId: value.countryId,
                swift: value.swift,
                address: value.address
            });
        } else {
            remasteredValues.push({
                id: value.id,
                name: value.name
            });
        }
    });

    lookups[name] = remasteredValues;

    console.log('Saved lookup ' + name + ' with ' + values.length + ' values.')
}

export function GetLookup(name) {
    return lookups[name];
}

export function GetLookupValueName(lookupName, id) {
    let lookup = lookups[lookupName];

    if (!lookup) {
        return 'Undefined';
    }

    let value = lookup.find(e => e.id === id);

    if (!value) {
        return 'Undefined';
    }

    return value.name;
}

export function GetLookupValue(lookupName, id) {
    let lookup = lookups[lookupName];

    if (!lookup) {
        return 'Undefined';
    }

    let value = lookup.find(e => e.id === id);

    if (!value) {
        return 'Undefined';
    }

    return value;
}

export function GetLookupMenuItems(name, excludeId = null) {
    let lookup = lookups[name];

    if (lookup) {
        let items = [];
        lookup.forEach((elem) => {
            if (excludeId && elem.id === excludeId) {
                return;
            }
            if (name === 'ownBankAccounts') {
                let assetName = GetLookupValueName('asset', elem.assetId);
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {`${elem.name} (${assetName})`}
                    </MenuItem>
                );
            } else {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {elem.name}
                    </MenuItem>
                );
            }

        });

        return items;
    }
}

export function GetAssetLookupMenuItemsByType(type) {
    let lookup = lookups['asset'];

    if (lookup) {
        let items = [];
        lookup.forEach((elem) => {
            if (elem.type === type) {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {elem.name}
                    </MenuItem>
                );
            }
        });

        return items;
    }
}